import type { ShipmentColumn } from '../../types/column-types'
import Id from '../../components/cells/id/id'
import { onCellStandard } from '../../helpers/helpers'
import type { DataSourceItem } from '../../shipments-page'

export const shipmentIdColumn: ShipmentColumn = {
    key: 'shipmentId',
    dataIndex: 'id',
    title: 'Номер',
    width: 60,
    onCell: onCellStandard,
    render: (_v, record: DataSourceItem) => <Id data={record} />,
}
